import React, { useState } from 'react';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(product.variants?.[0]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price / 100);
  };

  const handleAddToCart = async () => {
    if (!selectedVariant) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: selectedVariant.id,
          quantity: 1
        })
      });

      if (response.ok) {
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  return (
    <div 
      className="react-product-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
        transition: 'transform 0.2s ease',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.1)' : '0 2px 4px rgba(0,0,0,0.05)'
      }}
    >
      {product.featured_image && (
        <img 
          src={product.featured_image}
          alt={product.title}
          style={{
            width: '100%',
            height: '200px',
            objectFit: 'cover',
            borderRadius: '4px',
            marginBottom: '12px'
          }}
        />
      )}
      
      <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600' }}>
        {product.title}
      </h3>
      
      {selectedVariant && (
        <div style={{ marginBottom: '12px' }}>
          <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#2c5aa0' }}>
            {formatPrice(selectedVariant.price)}
          </span>
          {selectedVariant.compare_at_price > selectedVariant.price && (
            <span style={{ 
              marginLeft: '8px', 
              fontSize: '14px', 
              textDecoration: 'line-through',
              color: '#666' 
            }}>
              {formatPrice(selectedVariant.compare_at_price)}
            </span>
          )}
        </div>
      )}

      {product.variants && product.variants.length > 1 && (
        <select 
          value={selectedVariant?.id || ''}
          onChange={(e) => {
            const variant = product.variants.find(v => v.id.toString() === e.target.value);
            setSelectedVariant(variant);
          }}
          style={{
            width: '100%',
            padding: '8px',
            marginBottom: '12px',
            border: '1px solid #ccc',
            borderRadius: '4px'
          }}
        >
          {product.variants.map(variant => (
            <option key={variant.id} value={variant.id}>
              {variant.title} - {formatPrice(variant.price)}
            </option>
          ))}
        </select>
      )}

      <button
        onClick={handleAddToCart}
        disabled={!selectedVariant?.available}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: selectedVariant?.available ? '#2c5aa0' : '#ccc',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: selectedVariant?.available ? 'pointer' : 'not-allowed',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          if (selectedVariant?.available) {
            e.target.style.backgroundColor = '#1e3d6f';
          }
        }}
        onMouseLeave={(e) => {
          if (selectedVariant?.available) {
            e.target.style.backgroundColor = '#2c5aa0';
          }
        }}
      >
        {selectedVariant?.available ? 'Add to Cart' : 'Sold Out'}
      </button>
    </div>
  );
};

export default ProductCard;